import React from "react";
import { HashLink } from "react-router-hash-link";

function FooterMoreLinks({ data }) {
    return (
        <div key={'footer-more-links-'.concat(data.label)} className={"footer-more-links"}>
            <div className={'fixed-height-footer-link'}>
                <strong>
                    {data.url.includes("#") ?
                        <HashLink smooth to={data.url}
                                  scroll={(el) => el.scrollIntoView({behavior: 'instant', block: 'end'})}>
                            {data.label}
                        </HashLink>
                        : <a target="" className="white-text more-footer-link"
                             href={data.url}>{data.label}</a>
                    }
                </strong>
            </div>
        </div>

    );
}

export default FooterMoreLinks;
